(() => {
  if (window.cardProductActionsInitialized) return;
  window.cardProductActionsInitialized = true;

  function loadProductFormScript() {
    if (customElements.get('product-form')) return;
    const src = window.manasProductFormScript;
    if (!src || document.querySelector('script[src="' + src + '"]')) return;

    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  }

  loadProductFormScript();

  function itemMatches(item, productId, productHandle) {
    if (item && typeof item === 'object') {
      return String(item.id || '').trim() === productId || String(item.handle || '').trim() === productHandle;
    }

    const itemStr = String(item).trim();
    return itemStr === productId || itemStr === productHandle;
  }

  function getStoredItems(storageKey) {
    try {
      const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      console.error('Error reading ' + storageKey + ':', error);
      return [];
    }
  }

  function getCompareProduct(button) {
    return {
      id: button.dataset.productId || '',
      handle: button.dataset.productHandle || '',
      title: button.dataset.productTitle || '',
      url: button.dataset.productUrl || '#',
      image: button.dataset.productImage || '',
    };
  }

  function updateActionGroup(button) {
    const group = button.closest('.card__action-buttons');
    if (!group) return;

    group.classList.toggle('has-active-action', Boolean(group.querySelector('.is-favorited, .is-compared')));
  }

  function removeWishlistPageCard(button) {
    const grid = button.closest('#wishlist-product-grid');
    if (!grid) return false;

    const item = button.closest('.grid__item');
    if (item) item.remove();

    if (grid.querySelectorAll('.grid__item').length === 0) {
      const wishlistSection = grid.closest('.collection, .main-page-wishlist') || document;
      const emptyState =
        wishlistSection.querySelector('#WishlistEmptyState') ||
        wishlistSection.querySelector('[data-wishlist-empty]');

      if (emptyState) {
        emptyState.classList.remove('hidden');
        emptyState.classList.add('is-active');
      }
    }

    return true;
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function updateCardColorImage(radio) {
    if (!radio || !radio.dataset.cardColorImageSrc) return;

    const cardWrapper = radio.closest('.card-wrapper');
    const image = cardWrapper ? cardWrapper.querySelector('.card__media img.motion-reduce') : null;
    if (!image) return;

    image.src = radio.dataset.cardColorImageSrc;
    if (radio.dataset.cardColorImageSrcset) {
      image.srcset = radio.dataset.cardColorImageSrcset;
    }
    if (radio.dataset.cardColorImageAlt) {
      image.alt = radio.dataset.cardColorImageAlt;
    }
  }

  function syncCardColorSwatches(root = document) {
    root.querySelectorAll('.card__color-radio:checked').forEach((radio) => {
      const cardWrapper = radio.closest('.card-wrapper');
      const label = cardWrapper ? cardWrapper.querySelector(`label[for="${escapeSelector(radio.id)}"]`) : null;
      if (label && label.classList.contains('card__color-swatch')) {
        label.classList.add('selected', 'is-selected');
      }
    });
  }

  function selectCardColor(radio) {
    if (!radio) return;

    const cardWrapper = radio.closest('.card-wrapper');
    const radioGroup = document.querySelectorAll(`input[type="radio"][name="${escapeSelector(radio.name)}"]`);

    radioGroup.forEach((groupRadio) => {
      groupRadio.checked = false;
    });

    if (cardWrapper) {
      cardWrapper.querySelectorAll('.card__color-swatch').forEach((swatch) => {
        swatch.classList.remove('selected', 'is-selected');
      });
    }

    radio.checked = true;
    const label = cardWrapper ? cardWrapper.querySelector(`label[for="${escapeSelector(radio.id)}"]`) : null;
    if (label && label.classList.contains('card__color-swatch')) {
      label.classList.add('selected', 'is-selected');
    }
    updateCardColorImage(radio);
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function playCardHoverVideo(media) {
    const video = media ? media.querySelector('.card__hover-video') : null;
    if (!video) return;

    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function resetCardHoverVideo(media) {
    const video = media ? media.querySelector('.card__hover-video') : null;
    if (!video) return;

    video.pause();
    video.currentTime = 0;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeCompareItems(items) {
    const seen = new Set();

    return items
      .map((item) => {
        if (item && typeof item === 'object') {
          return {
            id: String(item.id || '').trim(),
            handle: String(item.handle || '').trim(),
            title: String(item.title || '').trim(),
            url: String(item.url || '#').trim() || '#',
            image: String(item.image || '').trim(),
          };
        }

        return {
          id: String(item || '').trim(),
          handle: '',
          title: '',
          url: '#',
          image: '',
        };
      })
      .filter((item) => {
        const key = item.id || item.handle;
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function getComparePageUrl() {
    return window.manasComparePageUrl || '/pages/compare';
  }

  function syncCompareDrawerLink(drawer) {
    const compareLink = drawer ? drawer.querySelector('.pdp-compare-drawer__compare-button') : null;
    if (compareLink) compareLink.href = getComparePageUrl();
    return compareLink;
  }

  function ensureCompareDrawer() {
    let drawer = document.getElementById('PdpCompareDrawer');
    if (drawer) {
      syncCompareDrawerLink(drawer);
      return drawer;
    }

    drawer = document.createElement('aside');
    drawer.id = 'PdpCompareDrawer';
    drawer.className = 'pdp-compare-drawer';
    drawer.setAttribute('aria-label', 'Compare products');
    drawer.innerHTML = `
      <div class="pdp-compare-drawer__inner">
        <button type="button" class="pdp-compare-drawer__close" data-compare-close aria-label="Close compare products">
          <svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
        </button>
        <h2 class="pdp-compare-drawer__title">Compare Products</h2>
        <div class="pdp-compare-drawer__carousel">
          <button type="button" class="pdp-compare-drawer__arrow pdp-compare-drawer__arrow--prev" data-compare-scroll="prev" aria-label="Previous compare products">
            <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
          </button>
          <div class="pdp-compare-drawer__items" data-compare-items></div>
          <button type="button" class="pdp-compare-drawer__arrow pdp-compare-drawer__arrow--next" data-compare-scroll="next" aria-label="Next compare products">
            <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
          </button>
        </div>
        <div class="pdp-compare-drawer__actions">
          <a href="${getComparePageUrl()}" class="button button--primary pdp-compare-drawer__compare-button"><span>Compare</span></a>
          <button type="button" class="pdp-compare-drawer__clear" data-compare-clear>Clear All</button>
        </div>
      </div>
    `;
    document.body.appendChild(drawer);

    const compareLink = syncCompareDrawerLink(drawer);
    if (window.ManasTheme) {
      window.ManasTheme.applyPrimaryButtonModifier(compareLink);
      window.ManasTheme.ensureButtonLabelSpan(compareLink);
    }

    drawer.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-compare-remove]');
      const closeButton = event.target.closest('[data-compare-close]');
      const clearButton = event.target.closest('[data-compare-clear]');
      const scrollButton = event.target.closest('[data-compare-scroll]');

      if (closeButton) {
        drawer.classList.remove('is-open');
        return;
      }

      if (clearButton) {
        localStorage.setItem('manas_compare', JSON.stringify([]));
        window.renderPdpCompareDrawer([], false);
        window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: [] } }));
        return;
      }

      if (scrollButton) {
        const itemsContainer = drawer.querySelector('[data-compare-items]');
        const direction = scrollButton.dataset.compareScroll === 'prev' ? -1 : 1;
        itemsContainer.scrollBy({
          left: direction * Math.max(itemsContainer.clientWidth * 0.8, 180),
          behavior: 'smooth',
        });
        return;
      }

      if (removeButton) {
        const productId = removeButton.dataset.productId;
        const productHandle = removeButton.dataset.productHandle;
        const compare = getStoredItems('manas_compare').filter((item) => !itemMatches(item, productId, productHandle));
        localStorage.setItem('manas_compare', JSON.stringify(compare));
        window.renderPdpCompareDrawer(compare, compare.length > 0);
        window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: compare } }));
      }
    });

    return drawer;
  }

  if (typeof window.renderPdpCompareDrawer !== 'function') {
    window.renderPdpCompareDrawer = function renderPdpCompareDrawer(
      items = getStoredItems('manas_compare'),
      shouldOpen = false
    ) {
      const drawer = ensureCompareDrawer();
      const normalizedItems = normalizeCompareItems(items);
      const itemsContainer = drawer.querySelector('[data-compare-items]');

      itemsContainer.innerHTML = normalizedItems
        .map((item) => {
          const title = escapeHtml(item.title || item.handle || item.id);
          const image = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${title}" loading="lazy">`
            : `<span class="pdp-compare-drawer__placeholder" aria-hidden="true"></span>`;

          return `
            <div class="pdp-compare-drawer__item">
              <button
                type="button"
                class="pdp-compare-drawer__remove"
                data-compare-remove
                data-product-id="${escapeHtml(item.id)}"
                data-product-handle="${escapeHtml(item.handle)}"
                aria-label="Remove ${title} from compare"
              ><svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>
              <a href="${escapeHtml(item.url)}" class="pdp-compare-drawer__product">
                ${image}
                <span class="pdp-compare-drawer__product-title">${title}</span>
              </a>
            </div>
          `;
        })
        .join('');

      drawer.classList.toggle('is-empty', normalizedItems.length === 0);
      drawer.classList.toggle('has-carousel', normalizedItems.length > 1);
      if (shouldOpen && normalizedItems.length > 0) {
        drawer.classList.add('is-open');
        itemsContainer.scrollTo({ left: 0, behavior: 'auto' });
      }
      if (normalizedItems.length === 0) {
        drawer.classList.remove('is-open');
      }
    };
  }

  function initCardProductActionState() {
    const wishlist = getStoredItems('manas_wishlist');
    document.querySelectorAll('.card__wishlist-button').forEach((button) => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isInWishlist = wishlist.some((item) => itemMatches(item, productId, productHandle));
      button.classList.toggle('is-favorited', isInWishlist);
      const label = isInWishlist ? button.dataset.removeLabel || 'Remove from wishlist' : button.dataset.addLabel || 'Add to wishlist';
      button.setAttribute('aria-label', label);
      button.dataset.tooltip = label;
      updateActionGroup(button);
    });

    const compare = getStoredItems('manas_compare');
    document.querySelectorAll('.card__compare-button').forEach((button) => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isCompared = compare.some((item) => itemMatches(item, productId, productHandle));
      button.classList.toggle('is-compared', isCompared);
      const label = isCompared ? button.dataset.removeLabel || 'Remove from compare' : button.dataset.addLabel || 'Compare product';
      button.setAttribute('aria-label', label);
      button.dataset.tooltip = label;
      updateActionGroup(button);
    });
  }

  document.addEventListener('click', (event) => {
    const wishlistButton = event.target.closest('.card__wishlist-button');
    const compareButton = event.target.closest('.card__compare-button');
    const button = wishlistButton || compareButton;
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      if (!productId && !productHandle) return;

      if (wishlistButton) {
        let wishlist = getStoredItems('manas_wishlist');
        const isInWishlist = wishlist.some((item) => itemMatches(item, productId, productHandle));
        const isWishlistPageCard = Boolean(wishlistButton.closest('#wishlist-product-grid'));

        wishlist = isInWishlist
          ? wishlist.filter((item) => !itemMatches(item, productId, productHandle))
          : [
              ...wishlist,
              {
                id: productId || '',
                handle: productHandle || '',
              },
            ];

        localStorage.setItem('manas_wishlist', JSON.stringify(wishlist));
        wishlistButton.classList.toggle('is-favorited', !isInWishlist);
        const wishlistLabel = !isInWishlist
          ? wishlistButton.dataset.removeLabel || 'Remove from wishlist'
          : wishlistButton.dataset.addLabel || 'Add to wishlist';
        wishlistButton.setAttribute('aria-label', wishlistLabel);
        wishlistButton.dataset.tooltip = wishlistLabel;
        updateActionGroup(wishlistButton);
        window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));

        if (isWishlistPageCard) {
          removeWishlistPageCard(wishlistButton);
        }

        return;
      }

      let compare = getStoredItems('manas_compare');
      const isCompared = compare.some((item) => itemMatches(item, productId, productHandle));

      compare = isCompared
        ? compare.filter((item) => !itemMatches(item, productId, productHandle))
        : [getCompareProduct(compareButton), ...compare];

      localStorage.setItem('manas_compare', JSON.stringify(compare));
      compareButton.classList.toggle('is-compared', !isCompared);
      const compareLabel = !isCompared
        ? compareButton.dataset.removeLabel || 'Remove from compare'
        : compareButton.dataset.addLabel || 'Compare product';
      compareButton.setAttribute('aria-label', compareLabel);
      compareButton.dataset.tooltip = compareLabel;
      updateActionGroup(compareButton);
      window.renderPdpCompareDrawer(compare, !isCompared);
      window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: compare } }));
      return;
    }

    if (event.defaultPrevented) return;

    const colorSwatch = event.target.closest('.card__color-swatch');
    const colorRadio = event.target.closest('.card__color-radio');
    if (colorSwatch || colorRadio) {
      const radio = colorRadio || document.getElementById(colorSwatch.getAttribute('for'));
      event.preventDefault();
      event.stopPropagation();
      selectCardColor(radio);
    }
  }, true);

  document.addEventListener('mouseover', (event) => {
    const media = event.target.closest('.card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    playCardHoverVideo(media);
  });

  document.addEventListener('mouseout', (event) => {
    const media = event.target.closest('.card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    resetCardHoverVideo(media);
  });

  document.addEventListener('focusin', (event) => {
    const media = event.target.closest('.card__media');
    playCardHoverVideo(media);
  });

  document.addEventListener('focusout', (event) => {
    const media = event.target.closest('.card__media');
    if (!media || media.contains(event.relatedTarget)) return;
    resetCardHoverVideo(media);
  });

  window.addEventListener('wishlist:updated', initCardProductActionState);
  window.addEventListener('compare:updated', initCardProductActionState);

  const init = () => {
    initCardProductActionState();
    syncCardColorSwatches();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  if (window.cardProductQuickAddInitialized) return;
  window.cardProductQuickAddInitialized = true;

  var cardProductStrings = window.cardProductStrings || {
    chooseOptions: 'Choose options',
    close: 'Close',
    loadError: 'Error loading product. Please try again.',
    addToWishlist: 'Add to wishlist',
    removeFromWishlist: 'Remove from wishlist'
  };

function cardProductItemMatches(item, productId, productHandle) {
  if (item && typeof item === 'object') {
    return String(item.id || '').trim() === productId || String(item.handle || '').trim() === productHandle;
  }

  const itemStr = String(item).trim();
  return itemStr === productId || itemStr === productHandle;
}

function getCardStoredItems(storageKey) {
  try {
    const items = JSON.parse(localStorage.getItem(storageKey) || '[]');
    return Array.isArray(items) ? items : [];
  } catch (e) {
    console.error('Error reading ' + storageKey + ':', e);
    return [];
  }
}

function getCardCompareProduct(button) {
  return {
    id: button.dataset.productId || '',
    handle: button.dataset.productHandle || '',
    title: button.dataset.productTitle || '',
    url: button.dataset.productUrl || '#',
    image: button.dataset.productImage || ''
  };
}

function updateCardActionGroup(button) {
  const group = button.closest('.card__action-buttons');
  if (!group) return;

  group.classList.toggle('has-active-action', Boolean(group.querySelector('.is-favorited, .is-compared')));
}

function setQuickAddProductActionState(button, isActive) {
  button.classList.toggle('is-active', isActive);

  const label = isActive
    ? button.dataset.removeLabel || button.getAttribute('aria-label')
    : button.dataset.addLabel || button.getAttribute('aria-label');

  if (label) {
    button.setAttribute('aria-label', label);
    button.dataset.tooltip = label;
  }
}

function escapeCardCompareHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function normalizeCardCompareItems(items) {
  const seen = new Set();

  return items
    .map(item => {
      if (item && typeof item === 'object') {
        return {
          id: String(item.id || '').trim(),
          handle: String(item.handle || '').trim(),
          title: String(item.title || '').trim(),
          url: String(item.url || '#').trim() || '#',
          image: String(item.image || '').trim()
        };
      }

      return {
        id: String(item || '').trim(),
        handle: '',
        title: '',
        url: '#',
        image: ''
      };
    })
    .filter(item => {
      const key = item.id || item.handle;
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

function getCardComparePageUrl() {
  return window.manasComparePageUrl || '/pages/compare';
}

function syncCardCompareDrawerLink(drawer) {
  const compareLink = drawer ? drawer.querySelector('.pdp-compare-drawer__compare-button') : null;
  if (compareLink) compareLink.href = getCardComparePageUrl();
  return compareLink;
}

function ensureCardCompareDrawer() {
  let drawer = document.getElementById('PdpCompareDrawer');
  if (drawer) {
    syncCardCompareDrawerLink(drawer);
    return drawer;
  }

  drawer = document.createElement('aside');
  drawer.id = 'PdpCompareDrawer';
  drawer.className = 'pdp-compare-drawer';
  drawer.setAttribute('aria-label', 'Compare products');
  drawer.innerHTML = `
    <div class="pdp-compare-drawer__inner">
      <button type="button" class="pdp-compare-drawer__close" data-compare-close aria-label="Close compare products">
        <svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
      </button>
      <h2 class="pdp-compare-drawer__title">Compare Products</h2>
      <div class="pdp-compare-drawer__carousel">
        <button type="button" class="pdp-compare-drawer__arrow pdp-compare-drawer__arrow--prev" data-compare-scroll="prev" aria-label="Previous compare products">
          <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
        </button>
        <div class="pdp-compare-drawer__items" data-compare-items></div>
        <button type="button" class="pdp-compare-drawer__arrow pdp-compare-drawer__arrow--next" data-compare-scroll="next" aria-label="Next compare products">
          <svg class="icon icon-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"></path></svg>
        </button>
      </div>
      <div class="pdp-compare-drawer__actions">
        <a href="${getCardComparePageUrl()}" class="button ${window.manasPrimaryButtonClass || 'button--primary'} pdp-compare-drawer__compare-button"><span>Compare</span></a>
        <button type="button" class="pdp-compare-drawer__clear" data-compare-clear>Clear All</button>
      </div>
    </div>
  `;
  document.body.appendChild(drawer);

  const compareLink = syncCardCompareDrawerLink(drawer);
  if (window.ManasTheme) {
    window.ManasTheme.applyPrimaryButtonModifier(compareLink);
    window.ManasTheme.ensureButtonLabelSpan(compareLink);
  }

  drawer.addEventListener('click', function(event) {
    const removeButton = event.target.closest('[data-compare-remove]');
    const closeButton = event.target.closest('[data-compare-close]');
    const clearButton = event.target.closest('[data-compare-clear]');
    const scrollButton = event.target.closest('[data-compare-scroll]');

    if (closeButton) {
      drawer.classList.remove('is-open');
      return;
    }

    if (clearButton) {
      localStorage.setItem('manas_compare', JSON.stringify([]));
      window.renderPdpCompareDrawer([], false);
      window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: [] } }));
      return;
    }

    if (scrollButton) {
      const itemsContainer = drawer.querySelector('[data-compare-items]');
      const direction = scrollButton.dataset.compareScroll === 'prev' ? -1 : 1;
      itemsContainer.scrollBy({
        left: direction * Math.max(itemsContainer.clientWidth * 0.8, 180),
        behavior: 'smooth'
      });
      return;
    }

    if (removeButton) {
      const productId = removeButton.dataset.productId;
      const productHandle = removeButton.dataset.productHandle;
      const compare = getCardStoredItems('manas_compare').filter(
        item => !cardProductItemMatches(item, productId, productHandle)
      );
      localStorage.setItem('manas_compare', JSON.stringify(compare));
      window.renderPdpCompareDrawer(compare, compare.length > 0);
      window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: compare } }));
    }
  });

  return drawer;
}

if (typeof window.renderPdpCompareDrawer !== 'function') {
  window.renderPdpCompareDrawer = function(items = getCardStoredItems('manas_compare'), shouldOpen = false) {
    const drawer = ensureCardCompareDrawer();
    const normalizedItems = normalizeCardCompareItems(items);
    const itemsContainer = drawer.querySelector('[data-compare-items]');

    itemsContainer.innerHTML = normalizedItems.map(item => {
      const title = escapeCardCompareHtml(item.title || item.handle || item.id);
      const image = item.image
        ? `<img src="${escapeCardCompareHtml(item.image)}" alt="${title}" loading="lazy">`
        : `<span class="pdp-compare-drawer__placeholder" aria-hidden="true"></span>`;

      return `
        <div class="pdp-compare-drawer__item">
          <button
            type="button"
            class="pdp-compare-drawer__remove"
            data-compare-remove
            data-product-id="${escapeCardCompareHtml(item.id)}"
            data-product-handle="${escapeCardCompareHtml(item.handle)}"
            aria-label="Remove ${title} from compare"
          ><svg viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>
          <a href="${escapeCardCompareHtml(item.url)}" class="pdp-compare-drawer__product">
            ${image}
            <span class="pdp-compare-drawer__product-title">${title}</span>
          </a>
        </div>
      `;
    }).join('');

    drawer.classList.toggle('is-empty', normalizedItems.length === 0);
    drawer.classList.toggle('has-carousel', normalizedItems.length > 1);
    if (shouldOpen && normalizedItems.length > 0) {
      drawer.classList.add('is-open');
      itemsContainer.scrollTo({ left: 0, behavior: 'auto' });
    }
    if (normalizedItems.length === 0) {
      drawer.classList.remove('is-open');
    }
  };
}

// Initialize wishlist and compare state from localStorage
function initCardProductActionState() {
  try {
    const wishlist = getCardStoredItems('manas_wishlist');
    document.querySelectorAll('.card__wishlist-button').forEach(button => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isInWishlist = wishlist.some(item => cardProductItemMatches(item, productId, productHandle));
      if (isInWishlist) {
        button.classList.add('is-favorited');
        button.setAttribute('aria-label', cardProductStrings.removeFromWishlist);
        button.dataset.tooltip = cardProductStrings.removeFromWishlist;
      } else {
        button.classList.remove('is-favorited');
        button.setAttribute('aria-label', cardProductStrings.addToWishlist);
        button.dataset.tooltip = cardProductStrings.addToWishlist;
      }
      updateCardActionGroup(button);
    });

    const compare = getCardStoredItems('manas_compare');
    document.querySelectorAll('.card__compare-button').forEach(button => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isCompared = compare.some(item => cardProductItemMatches(item, productId, productHandle));
      button.classList.toggle('is-compared', isCompared);
      button.setAttribute('aria-label', isCompared ? 'Remove from compare' : 'Compare product');
      button.dataset.tooltip = isCompared ? 'Remove from compare' : 'Compare product';
      updateCardActionGroup(button);
    });

    document.querySelectorAll('quick-add-modal .product-form__wishlist-button').forEach(button => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isInWishlist = wishlist.some(item => cardProductItemMatches(item, productId, productHandle));
      setQuickAddProductActionState(button, isInWishlist);
    });

    document.querySelectorAll('quick-add-modal .product-form__compare-button').forEach(button => {
      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;
      const isCompared = compare.some(item => cardProductItemMatches(item, productId, productHandle));
      setQuickAddProductActionState(button, isCompared);
    });
  } catch (e) {
    console.error('Error initializing card action state:', e);
  }
}

if (!window.cardProductInlineActionsInitialized) {
  window.cardProductInlineActionsInitialized = true;

  // Initialize on page load and after dynamic content loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardProductActionState);
  } else {
    initCardProductActionState();
  }
  // Re-initialize when actions are updated from other components
  window.addEventListener('wishlist:updated', function() {
    initCardProductActionState();
  });
  window.addEventListener('compare:updated', function() {
    initCardProductActionState();
  });

  // Handle wishlist button clicks
  document.addEventListener('click', function(e) {
    const wishlistButton = e.target.closest('.card__wishlist-button');
    if (!wishlistButton) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = wishlistButton.dataset.productId;
    const productHandle = wishlistButton.dataset.productHandle;
    if (!productId && !productHandle) return;

    try {
      let wishlist = getCardStoredItems('manas_wishlist');

      // Check if product is in wishlist (by ID or handle)
      const isInWishlist = wishlist.some(item => cardProductItemMatches(item, productId, productHandle));

      if (isInWishlist) {
        // Remove from wishlist
        wishlist = wishlist.filter(item => !cardProductItemMatches(item, productId, productHandle));
        wishlistButton.classList.remove('is-favorited');
        wishlistButton.setAttribute('aria-label', cardProductStrings.addToWishlist);
        wishlistButton.dataset.tooltip = cardProductStrings.addToWishlist;
      } else {
        wishlist.push({
          id: productId || '',
          handle: productHandle || ''
        });
        wishlistButton.classList.add('is-favorited');
        wishlistButton.setAttribute('aria-label', cardProductStrings.removeFromWishlist);
        wishlistButton.dataset.tooltip = cardProductStrings.removeFromWishlist;
      }
      updateCardActionGroup(wishlistButton);

      localStorage.setItem('manas_wishlist', JSON.stringify(wishlist));

      // Dispatch custom event for other components (e.g., header wishlist count)
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
    } catch (e) {
      console.error('Error updating wishlist:', e);
    }
  });

  // Handle compare button clicks
  document.addEventListener('click', function(e) {
    const compareButton = e.target.closest('.card__compare-button');
    if (!compareButton) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = compareButton.dataset.productId;
    const productHandle = compareButton.dataset.productHandle;
    if (!productId && !productHandle) return;

    try {
      let compare = getCardStoredItems('manas_compare');
      const isCompared = compare.some(item => cardProductItemMatches(item, productId, productHandle));

      if (isCompared) {
        compare = compare.filter(item => !cardProductItemMatches(item, productId, productHandle));
        compareButton.classList.remove('is-compared');
        compareButton.setAttribute('aria-label', 'Compare product');
        compareButton.dataset.tooltip = 'Compare product';
      } else {
        compare.unshift(getCardCompareProduct(compareButton));
        compareButton.classList.add('is-compared');
        compareButton.setAttribute('aria-label', 'Remove from compare');
        compareButton.dataset.tooltip = 'Remove from compare';
      }
      updateCardActionGroup(compareButton);

      localStorage.setItem('manas_compare', JSON.stringify(compare));
      if (typeof window.renderPdpCompareDrawer === 'function') {
        window.renderPdpCompareDrawer(compare, !isCompared);
      }
      window.dispatchEvent(new CustomEvent('compare:updated', { detail: { items: compare } }));
    } catch (e) {
      console.error('Error updating compare:', e);
    }
  });

  // Handle product action buttons rendered inside quick add modals when product-info.js is not present.
  document.addEventListener('click', function(e) {
    const wishlistButton = e.target.closest('quick-add-modal .product-form__wishlist-button');
    const compareButton = e.target.closest('quick-add-modal .product-form__compare-button');
    const button = wishlistButton || compareButton;
    if (!button || window.pdpProductActionsInitialized) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = button.dataset.productId;
    const productHandle = button.dataset.productHandle;
    if (!productId && !productHandle) return;

    const storageKey = wishlistButton ? 'manas_wishlist' : 'manas_compare';
    const eventName = wishlistButton ? 'wishlist:updated' : 'compare:updated';

    try {
      let items = getCardStoredItems(storageKey);
      const isActive = items.some(item => cardProductItemMatches(item, productId, productHandle));

      if (isActive) {
        items = items.filter(item => !cardProductItemMatches(item, productId, productHandle));
      } else if (compareButton) {
        items.unshift(getCardCompareProduct(button));
      } else {
        items.push({
          id: productId || '',
          handle: productHandle || ''
        });
      }

      localStorage.setItem(storageKey, JSON.stringify(items));
      setQuickAddProductActionState(button, !isActive);

      if (compareButton && typeof window.renderPdpCompareDrawer === 'function') {
        window.renderPdpCompareDrawer(items, !isActive);
      }

      window.dispatchEvent(new CustomEvent(eventName, { detail: { items } }));
    } catch (error) {
      console.error('Error updating quick add product action:', error);
    }
  });
}

if (!window.quickAddInitialized) {
  window.quickAddInitialized = true;

  // Initialize selected state for default checked radios
  function initializeColorSwatches() {
    document.querySelectorAll('.card__color-radio:checked').forEach(radio => {
      const label = document.querySelector(`label[for="${radio.id}"]`);
      if (label && label.classList.contains('card__color-swatch')) {
        label.classList.add('selected');
      }
      updateCardColorImage(radio);
    });
  }

  function updateCardColorImage(radio) {
    if (!radio || !radio.dataset.cardColorImageSrc) return;

    const cardWrapper = radio.closest('.card-wrapper');
    const image = cardWrapper ? cardWrapper.querySelector('.card__media img.motion-reduce') : null;
    if (!image) return;

    image.src = radio.dataset.cardColorImageSrc;
    if (radio.dataset.cardColorImageSrcset) {
      image.srcset = radio.dataset.cardColorImageSrcset;
    }
    if (radio.dataset.cardColorImageAlt) {
      image.alt = radio.dataset.cardColorImageAlt;
    }
  }

  function playCardHoverVideo(media) {
    const video = media ? media.querySelector('.card__hover-video') : null;
    if (!video) return;

    video.muted = true;
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  }

  function resetCardHoverVideo(media) {
    const video = media ? media.querySelector('.card__hover-video') : null;
    if (!video) return;

    video.pause();
    video.currentTime = 0;
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeColorSwatches);
  } else {
    initializeColorSwatches();
  }

  // Global overlay click handler
  document.addEventListener('click', function(e) {
    // Check if clicking on the overlay (not cart drawer)
    if (e.target.id === 'quick-add-overlay' || e.target.classList.contains('quick-add-overlay')) {
      hideLoadingOverlay();
      closeCartDrawer();
      return;
    }
  });

  // Handle color swatch click - prevent navigation, just select color
  document.addEventListener('click', function(e) {
    const colorSwatch = e.target.closest('.card__color-swatch');
    const colorRadio = e.target.closest('.card__color-radio');
    const colorContainer = e.target.closest('.card__colors');

    // Check if clicking on color swatch, radio, or inside color container
    if (colorSwatch || colorRadio || (colorContainer && e.target !== colorContainer && !e.target.closest('a'))) {
      e.preventDefault();
      e.stopPropagation();

      // Force select the radio button
      if (colorSwatch) {
        const radioId = colorSwatch.getAttribute('for');
        if (radioId) {
          const radio = document.getElementById(radioId);
          if (radio) {
            // Get all radios and labels in the same group
            const radioGroup = document.querySelectorAll(`input[type="radio"][name="${radio.name}"]`);
            const cardWrapper = radio.closest('.card-wrapper');

            // Remove selected class from all swatches in this card
            if (cardWrapper) {
              const allSwatches = cardWrapper.querySelectorAll('.card__color-swatch');
              allSwatches.forEach(swatch => swatch.classList.remove('selected', 'is-selected'));
            }

            // Uncheck all radios in the same group
            radioGroup.forEach(r => {
              r.checked = false;
              r.dispatchEvent(new Event('change', { bubbles: true }));
            });

            // Check the clicked radio
            radio.checked = true;
            colorSwatch.classList.add('selected', 'is-selected');
            updateCardColorImage(radio);
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            radio.dispatchEvent(new Event('click', { bubbles: true }));
          }
        }
      } else if (colorRadio) {
        // If clicking directly on radio, ensure it's checked
        const radioGroup = document.querySelectorAll(`input[type="radio"][name="${colorRadio.name}"]`);
        const cardWrapper = colorRadio.closest('.card-wrapper');

        // Remove selected class from all swatches in this card
        if (cardWrapper) {
          const allSwatches = cardWrapper.querySelectorAll('.card__color-swatch');
          allSwatches.forEach(swatch => swatch.classList.remove('selected', 'is-selected'));
        }

        // Uncheck all radios
        radioGroup.forEach(r => {
          r.checked = false;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // Check the clicked radio and add selected class to its label
        colorRadio.checked = true;
        const label = document.querySelector(`label[for="${colorRadio.id}"]`);
        if (label && label.classList.contains('card__color-swatch')) {
          label.classList.add('selected', 'is-selected');
        }
        updateCardColorImage(colorRadio);
        colorRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      return false;
    }
  }, true); // Use capture phase to catch event early

  // Also handle change event to sync selected class
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('card__color-radio')) {
      const cardWrapper = e.target.closest('.card-wrapper');
      if (cardWrapper) {
        const allSwatches = cardWrapper.querySelectorAll('.card__color-swatch');
        allSwatches.forEach(swatch => {
          const radioId = swatch.getAttribute('for');
          if (radioId) {
            const radio = document.getElementById(radioId);
            if (radio && radio.checked) {
              swatch.classList.add('selected', 'is-selected');
              updateCardColorImage(radio);
            } else {
              swatch.classList.remove('selected', 'is-selected');
            }
          }
        });
      }
    }
  });

  document.addEventListener('mouseover', function(e) {
    const media = e.target.closest('.card__media');
    if (!media || media.contains(e.relatedTarget)) return;
    playCardHoverVideo(media);
  });

  document.addEventListener('mouseout', function(e) {
    const media = e.target.closest('.card__media');
    if (!media || media.contains(e.relatedTarget)) return;
    resetCardHoverVideo(media);
  });

  document.addEventListener('focusin', function(e) {
    const media = e.target.closest('.card__media');
    playCardHoverVideo(media);
  });

  document.addEventListener('focusout', function(e) {
    const media = e.target.closest('.card__media');
    if (!media || media.contains(e.relatedTarget)) return;
    resetCardHoverVideo(media);
  });

  // Handle Quick Add modal trigger
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.quick-add-modal-trigger');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const productHandle = button.dataset.productHandle;
    const productId = button.dataset.productId;
    const sectionId = button.dataset.sectionId;

    if (!productHandle || !productId) return;

    // Open Quick Add modal
    const modalId = 'QuickAdd-' + productId;
    let modal = document.getElementById(modalId);

    // If modal doesn't exist, create it
    if (!modal) {
      modal = document.createElement('quick-add-modal');
      modal.id = modalId;
      modal.className = 'quick-add-modal';
      modal.innerHTML = `
        <div role="dialog" aria-label="${cardProductStrings.chooseOptions}" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
          <button id="ModalClose-${productId}" type="button" class="quick-add-modal__toggle" aria-label="${cardProductStrings.close}">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div id="QuickAddInfo-${productId}" class="quick-add-modal__content-info"></div>
        </div>
      `;
      document.body.appendChild(modal);
      if (typeof modal.bindCloseControls === 'function') {
        modal.bindCloseControls();
      }
    }

    if (typeof modal.bindCloseControls === 'function') {
      modal.bindCloseControls();
    }

    // Open modal without QuickAddModal.show() (needs data-product-url + loading spinner on opener).
    const openQuickAddModal = Object.getPrototypeOf(Object.getPrototypeOf(modal)).show;
    if (typeof openQuickAddModal === 'function') {
      openQuickAddModal.call(modal, button);
    } else {
      modal.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    }

    // Load product info into modal
    const infoContainer = modal.querySelector('.quick-add-modal__content-info');
    if (infoContainer) {
      infoContainer.classList.add('quick-add-modal__content-info--loading');
      infoContainer.innerHTML = `
        <div class="quick-add-modal__loading">
          <div class="loading__spinner">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </div>
      `;

      // Fetch complete product page (like quick-add.js does)
      fetch(button.dataset.productUrl || '/products/' + productHandle)
        .then(response => response.text())
        .then(responseText => {
          const innerHTML = new DOMParser().parseFromString(responseText, 'text/html');

          // Try to find product-info element (standard approach)
          let productInfo = innerHTML.querySelector('product-info');
          if (productInfo) {
            productInfo.querySelectorAll('product-modal').forEach(function (modalEl) {
              modalEl.remove();
            });
            if (typeof modal.preprocessHTML === 'function') {
              modal.preprocessHTML(productInfo);
            } else {
              productInfo.setAttribute('data-update-url', 'false');
            }
            infoContainer.classList.remove('quick-add-modal__content-info--loading');
            infoContainer.innerHTML = productInfo.outerHTML;
            initializeQuickAddMediaCarousel(infoContainer);
            layoutQuickAddBuyArea(infoContainer);
            initCardProductActionState();
            // Trigger any necessary scripts
            if (window.Shopify && window.Shopify.PaymentButton) {
              window.Shopify.PaymentButton.init();
            }
            if (window.ProductModel) {
              window.ProductModel.loadShopifyXR();
            }
            return;
          }

          // Fallback: build from JSON if product-info not found
          fetch('/products/' + productHandle + '.js')
            .then(res => res.json())
            .then(product => {
              infoContainer.classList.remove('quick-add-modal__content-info--loading');
              buildSimpleModal(product, infoContainer, modal);
            })
            .catch(() => {
              infoContainer.classList.remove('quick-add-modal__content-info--loading');
              infoContainer.innerHTML = '<p>' + cardProductStrings.loadError + '</p>';
            });
        })
        .catch(error => {
          console.error('Error loading product:', error);
          // Fallback to JSON
          fetch('/products/' + productHandle + '.js')
            .then(res => res.json())
            .then(product => {
              infoContainer.classList.remove('quick-add-modal__content-info--loading');
              buildSimpleModal(product, infoContainer, modal);
            })
            .catch(() => {
              infoContainer.classList.remove('quick-add-modal__content-info--loading');
              infoContainer.innerHTML = '<p>' + cardProductStrings.loadError + '</p>';
            });
        });
    }
  });

  function layoutQuickAddBuyArea(infoContainer) {
    const root = infoContainer.querySelector('product-info') || infoContainer;
    const legacyRow = root.querySelector('.quick-add-qty-buy-row');
    if (legacyRow) {
      const legacyForm = legacyRow.querySelector('product-form');
      const legacyQty = legacyRow.querySelector('.product-form__quantity');
      const parent = legacyRow.parentNode;
      if (parent) {
        if (legacyQty) parent.insertBefore(legacyQty, legacyRow);
        if (legacyForm) parent.insertBefore(legacyForm, legacyRow);
        legacyRow.remove();
      }
    }

    const productForm = root.querySelector('product-form');
    const qty = root.querySelector('.product-form__quantity');
    if (!productForm || !qty || productForm.dataset.quickAddBuyLayout === '1') return;

    const form = productForm.querySelector('form');
    const buttons = form && form.querySelector('.product-form__buttons');
    if (!form || !buttons) return;

    const submit =
      buttons.querySelector('.product-form__submit') ||
      buttons.querySelector('button[type="submit"][name="add"]');
    if (!submit) return;

    let payment = buttons.querySelector('.shopify-payment-button');
    if (!payment) {
      payment = buttons.querySelector('shopify-accelerated-checkout');
    }
    if (!payment) {
      payment = Array.from(buttons.children).find(function (el) {
        return el !== submit && el.querySelector && el.querySelector('shopify-accelerated-checkout');
      });
    }
    if (!payment) {
      payment = Array.from(buttons.children).find(function (el) {
        return el !== submit;
      });
    }
    if (payment === submit) payment = null;

    const stack = document.createElement('div');
    stack.className = 'quick-add-qty-buy-stack';

    const mainRow = document.createElement('div');
    mainRow.className = 'quick-add-buy-main-row';

    const submitWrap = document.createElement('div');
    submitWrap.className = 'quick-add-submit-wrap';

    mainRow.appendChild(qty);
    submitWrap.appendChild(submit);
    mainRow.appendChild(submitWrap);
    stack.appendChild(mainRow);

    if (payment) {
      const paymentRow = document.createElement('div');
      paymentRow.className = 'quick-add-payment-row';
      paymentRow.appendChild(payment);
      stack.appendChild(paymentRow);
    }

    while (buttons.firstChild) {
      buttons.removeChild(buttons.firstChild);
    }
    buttons.appendChild(stack);

    if (window.ManasTheme) {
      window.ManasTheme.applyPrimaryButtonModifier(submit);
      window.ManasTheme.ensureButtonLabelSpan(submit);
    }

    var buyButtons = productForm.closest('.product-form__buy-buttons');
    if (buyButtons) buyButtons.classList.remove('product-form__buy-buttons--loading');
    productForm.dataset.quickAddBuyLayout = '1';
  }

  function initializeQuickAddMediaCarousel(infoContainer) {
    const mediaWrapper = infoContainer.querySelector('.product__media-wrapper');
    const mediaList = mediaWrapper ? mediaWrapper.querySelector('.product__media-list') : null;
    if (!mediaWrapper || !mediaList) return;

    const mediaItems = Array.from(mediaList.querySelectorAll('.product__media-item'));
    if (mediaItems.length <= 1) return;

    const existingCarousel = mediaWrapper.querySelector('.quick-add-thumbnails');
    if (existingCarousel) existingCarousel.remove();
    const existingNav = mediaWrapper.querySelectorAll('.quick-add-media-nav');
    if (existingNav.length) existingNav.forEach((navButton) => navButton.remove());

    const nativeThumbnailSlider = mediaWrapper.querySelector('.thumbnail-slider');
    if (nativeThumbnailSlider) nativeThumbnailSlider.style.display = 'none';

    let activeIndex = 0;

    const ensureThumbnailVisibility = (index) => {
      const prevButton = thumbnailButtons[index - 1];
      if (prevButton) {
        const prevButtonLeftEdge = prevButton.offsetLeft;
        if (prevButtonLeftEdge < thumbnailTrack.scrollLeft) {
          thumbnailTrack.scrollTo({
            left: Math.max(prevButtonLeftEdge - 12, 0),
            behavior: 'smooth',
          });
          return;
        }
      }

      const nextButton = thumbnailButtons[index + 1];
      if (nextButton) {
        const trackRightEdge = thumbnailTrack.scrollLeft + thumbnailTrack.clientWidth;
        const nextButtonRightEdge = nextButton.offsetLeft + nextButton.offsetWidth;

        if (nextButtonRightEdge > trackRightEdge) {
          thumbnailTrack.scrollTo({
            left: nextButtonRightEdge - thumbnailTrack.clientWidth + 12,
            behavior: 'smooth',
          });
          return;
        }
      }

      const currentButton = thumbnailButtons[index];
      if (currentButton) {
        currentButton.scrollIntoView({
          behavior: 'smooth',
          inline: 'nearest',
          block: 'nearest',
        });
      }
    };

    const updateNavState = () => {
      if (prevNavButton) prevNavButton.disabled = activeIndex === 0;
      if (nextNavButton) nextNavButton.disabled = activeIndex === mediaItems.length - 1;
    };

    const setActiveMedia = (index) => {
      activeIndex = index;
      mediaItems.forEach((item, itemIndex) => {
        item.classList.toggle('quick-add-media-hidden', itemIndex !== index);
        item.classList.toggle('quick-add-media-active', itemIndex === index);
      });

      thumbnailButtons.forEach((button, buttonIndex) => {
        button.classList.toggle('is-active', buttonIndex === index);
        button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
      });

      updateNavState();
    };

    const prevNavButton = document.createElement('button');
    prevNavButton.type = 'button';
    prevNavButton.className = 'quick-add-media-nav quick-add-media-nav--prev';
    prevNavButton.setAttribute('aria-label', 'Previous image');
    prevNavButton.innerHTML = `
      <svg aria-hidden="true" focusable="false" role="presentation" width="30px" height="30px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000">
        <path d="M15 6l-6 6 6 6" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    const nextNavButton = document.createElement('button');
    nextNavButton.type = 'button';
    nextNavButton.className = 'quick-add-media-nav quick-add-media-nav--next';
    nextNavButton.setAttribute('aria-label', 'Next image');
    nextNavButton.innerHTML = `
      <svg aria-hidden="true" focusable="false" role="presentation" width="30px" height="30px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#000000">
        <path d="M9 6l6 6-6 6" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    const thumbnailTrack = document.createElement('div');
    thumbnailTrack.className = 'quick-add-thumbnails';
    const thumbnailButtons = [];

    mediaItems.forEach((item, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'quick-add-thumbnail';
      button.setAttribute('aria-label', `Show product image ${index + 1}`);

      const sourceImage = item.querySelector('img');
      if (sourceImage) {
        const thumbnailImage = document.createElement('img');
        thumbnailImage.src = sourceImage.currentSrc || sourceImage.src;
        thumbnailImage.alt = sourceImage.alt || `Product image ${index + 1}`;
        thumbnailImage.loading = 'lazy';
        button.appendChild(thumbnailImage);
      }

      button.addEventListener('click', () => {
        setActiveMedia(index);
        ensureThumbnailVisibility(index);
      });

      thumbnailButtons.push(button);
      thumbnailTrack.appendChild(button);
    });

    prevNavButton.addEventListener('click', () => {
      if (activeIndex <= 0) return;
      const nextIndex = activeIndex - 1;
      setActiveMedia(nextIndex);
      ensureThumbnailVisibility(nextIndex);
    });

    nextNavButton.addEventListener('click', () => {
      if (activeIndex >= mediaItems.length - 1) return;
      const nextIndex = activeIndex + 1;
      setActiveMedia(nextIndex);
      ensureThumbnailVisibility(nextIndex);
    });

    mediaWrapper.appendChild(prevNavButton);
    mediaWrapper.appendChild(nextNavButton);
    mediaWrapper.appendChild(thumbnailTrack);
    setActiveMedia(0);
  }

  // Helper function to build simple modal from JSON data
  function buildSimpleModal(product, infoContainer, modal) {
    // Clear existing content
    infoContainer.innerHTML = '';

    // Create product container
    const productDiv = document.createElement('div');
    productDiv.className = 'quick-add-product';

    // Create image container
    const imageDiv = document.createElement('div');
    imageDiv.className = 'quick-add-product__image';
    const img = document.createElement('img');
    img.src = product.featured_image;
    img.alt = product.title;
    img.width = 200;
    img.height = 200;
    imageDiv.appendChild(img);
    productDiv.appendChild(imageDiv);

    // Create info container
    const infoDiv = document.createElement('div');
    infoDiv.className = 'quick-add-product__info';

    // Title
    const title = document.createElement('h3');
    title.className = 'quick-add-product__title';
    title.textContent = product.title;
    infoDiv.appendChild(title);

    // Price
    const price = document.createElement('div');
    price.className = 'quick-add-product__price';
    price.textContent = '$' + (product.price / 100).toFixed(2);
    infoDiv.appendChild(price);

    // Variants
    let variantsHtml = '';
    if (product.variants && product.variants.length > 1) {
      variantsHtml = '<div class="quick-add-variants">';
      product.options.forEach((option, optionIndex) => {
        variantsHtml += '<div class="quick-add-option"><label>' + option.name + '</label><select class="quick-add-select" data-option-index="' + optionIndex + '">';
        option.values.forEach(value => {
          variantsHtml += '<option value="' + value + '">' + value + '</option>';
        });
        variantsHtml += '</select></div>';
      });
      variantsHtml += '</div>';
    }
    infoDiv.insertAdjacentHTML('beforeend', variantsHtml);

    // Create product-form element
    const productForm = document.createElement('product-form');
    productForm.setAttribute('data-section-id', 'quick-add-modal');

    // Create form
    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.acceptCharset = 'UTF-8';
    form.enctype = 'multipart/form-data';
    form.setAttribute('data-type', 'add-to-cart-form');

    // Form inputs
    const variantId = product.variants && product.variants.length > 0 ? product.variants[0].id : '';

    const idInput = document.createElement('input');
    idInput.type = 'hidden';
    idInput.name = 'id';
    idInput.value = variantId;
    idInput.className = 'product-variant-id';
    form.appendChild(idInput);

    const qtyInput = document.createElement('input');
    qtyInput.type = 'hidden';
    qtyInput.name = 'quantity';
    qtyInput.value = '1';
    form.appendChild(qtyInput);

    const sectionsInput = document.createElement('input');
    sectionsInput.type = 'hidden';
    sectionsInput.name = 'sections';
    sectionsInput.value = 'cart-drawer';
    form.appendChild(sectionsInput);

    const sectionsUrlInput = document.createElement('input');
    sectionsUrlInput.type = 'hidden';
    sectionsUrlInput.name = 'sections_url';
    sectionsUrlInput.value = window.location.pathname;
    form.appendChild(sectionsUrlInput);

    // Submit button
    const submitBtn = document.createElement('button');
    submitBtn.type = 'submit';
    submitBtn.className =
      'quick-add-product__submit button button--full-width ' +
      (window.ManasTheme ? window.ManasTheme.primaryButtonModifierClass() : 'button--primary');
    submitBtn.setAttribute('aria-haspopup', 'dialog');
    submitBtn.setAttribute('data-sold-out-message', 'true');

    const span = document.createElement('span');
    span.textContent = 'Add to cart';
    submitBtn.appendChild(span);

    const soldOutSpan = document.createElement('span');
    soldOutSpan.className = 'sold-out-message hidden';
    soldOutSpan.textContent = 'Sold out';
    submitBtn.appendChild(soldOutSpan);

    const spinner = document.createElement('div');
    spinner.className = 'loading__spinner hidden';
    spinner.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
    submitBtn.appendChild(spinner);

    form.appendChild(submitBtn);
    productForm.appendChild(form);
    infoDiv.appendChild(productForm);
    productDiv.appendChild(infoDiv);

    infoContainer.appendChild(productDiv);

    bindModalEvents(product, infoContainer, modal);
  }

  // Helper function to bind events
  function bindModalEvents(product, infoContainer, modal) {
    // Handle variant selection changes
    const selects = infoContainer.querySelectorAll('.quick-add-select');
    selects.forEach(select => {
      select.addEventListener('change', function() {
        // Find matching variant based on selected options
        const selectedOptions = Array.from(infoContainer.querySelectorAll('.quick-add-select')).map(s => s.value);
        const matchedVariant = product.variants.find(v => {
          return v.options.every((opt, i) => opt === selectedOptions[i]);
        });
        if (matchedVariant) {
          const variantInput = infoContainer.querySelector('.product-variant-id');
          if (variantInput) {
            variantInput.value = matchedVariant.id;
          }
          const submitBtn = infoContainer.querySelector('.quick-add-product__submit');
          if (submitBtn) {
            const span = submitBtn.querySelector('span:not(.sold-out-message)');
            const soldOutSpan = submitBtn.querySelector('.sold-out-message');
            if (!matchedVariant.available) {
              if (span) span.classList.add('hidden');
              if (soldOutSpan) soldOutSpan.classList.remove('hidden');
              submitBtn.disabled = true;
            } else {
              if (span) span.classList.remove('hidden');
              if (soldOutSpan) soldOutSpan.classList.add('hidden');
              submitBtn.disabled = false;
            }
          }
        }
      });
    });
  }

  // Fallback for dynamically-rendered product forms inside quick add modals.
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('quick-add-modal form[data-type="add-to-cart-form"]');
    if (!form || e.defaultPrevented) return;

    e.preventDefault();

    const productForm = form.closest('product-form');
    const modal = form.closest('quick-add-modal');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const submitButton = form.querySelector('[type="submit"]');
    const spinner = submitButton && submitButton.querySelector('.loading__spinner');

    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : {
      method: 'POST',
      headers: { Accept: 'application/json' }
    };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.delete('sections');
      formData.delete('sections_url');
      formData.append('sections', cart.getSectionsToRender().map(section => section.id));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', config)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          const errorWrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
          const errorMessage = errorWrapper && errorWrapper.querySelector('.product-form__error-message');
          if (errorWrapper) errorWrapper.toggleAttribute('hidden', false);
          if (errorMessage) errorMessage.textContent = response.description || response.message;
          return;
        }

        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = window.routes ? window.routes.cart_url : '/cart';
          return;
        }

        const renderCart = () => cart.renderContents(response);
        if (modal && typeof modal.hide === 'function') {
          document.body.addEventListener('modalClosed', renderCart, { once: true });
          modal.hide(true);
        } else {
          renderCart();
        }
      })
      .catch(error => {
        console.error('Error adding quick add modal product to cart:', error);
      })
      .finally(() => {
        if (submitButton) {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
  });

  // Handle add to cart button click (single variant).
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.card__quick-add-button:not(.quick-add-modal-trigger)');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = button.dataset.variantId;
    const productHandle = button.dataset.productHandle;
    if (!variantId) return;

    setQuickAddButtonLoading(button, true);

    // If product has a handle, fetch to check if it's actually a single variant
    // or if we need to show the modal for options
    if (productHandle) {
      fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(product => {
          if (product.variants && product.variants.length > 1) {
            // Multiple variants - trigger modal instead
            const modalTrigger = document.createElement('button');
            modalTrigger.className = 'quick-add-modal-trigger';
            modalTrigger.dataset.productId = product.id;
            modalTrigger.dataset.productHandle = productHandle;
            modalTrigger.dataset.productUrl = '/products/' + productHandle;
            modalTrigger.dataset.sectionId = '';
            document.body.appendChild(modalTrigger);
            modalTrigger.click();
            document.body.removeChild(modalTrigger);
            setQuickAddButtonLoading(button, false);
          } else {
            // Single variant - add directly
            addToCart(variantId, button);
          }
        })
        .catch(() => {
          // Fallback to direct add
          addToCart(variantId, button);
        });
    } else {
      addToCart(variantId, button);
    }
  });

  function addToCart(variantId, button) {
    if (!variantId) return;

    // Disable button and show loading state
    setQuickAddButtonLoading(button, true);

    // Show overlay with loading spinner
    showLoadingOverlay();

    // Add to cart
    var addToCartUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
    var addToCartConfig = (typeof fetchConfig === 'function' ? fetchConfig('json') : {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    });
    addToCartConfig.credentials = 'same-origin';
    addToCartConfig.body = JSON.stringify({
      id: variantId,
      quantity: 1
    });

    fetch(addToCartUrl, addToCartConfig)
    .then(response => response.json())
    .then(data => {
      // Update cart drawer and header cart icon
      Promise.all([
        fetch('/?section_id=cart-drawer').then(res => res.text()),
        fetch('/?section_id=cart-icon-bubble').then(res => res.text())
      ])
        .then(([cartDrawerHtml, cartIconHtml]) => {
          const parser = new DOMParser();

          // Parse cart drawer
          const cartDrawerDoc = parser.parseFromString(cartDrawerHtml, 'text/html');
          const newCartDrawer = cartDrawerDoc.querySelector('cart-drawer');
          const newCartDrawerItems = cartDrawerDoc.querySelector('cart-drawer-items');
          const currentCartDrawer = document.querySelector('cart-drawer');
          const currentCartDrawerItems = document.querySelector('cart-drawer-items');

          if (newCartDrawer && currentCartDrawer) {
            // Update is-empty state from server response
            if (newCartDrawer.classList.contains('is-empty')) {
              currentCartDrawer.classList.add('is-empty');
            } else {
              currentCartDrawer.classList.remove('is-empty');
            }

            // Update cart drawer content
            currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }

          // Update cart-drawer-items is-empty state
          if (newCartDrawerItems && currentCartDrawerItems) {
            if (newCartDrawerItems.classList.contains('is-empty')) {
              currentCartDrawerItems.classList.add('is-empty');
            } else {
              currentCartDrawerItems.classList.remove('is-empty');
            }
          }

          // Also check drawer__inner
          const currentDrawerInner = currentCartDrawer ? currentCartDrawer.querySelector('.drawer__inner') : null;
          const newDrawerInner = newCartDrawer ? newCartDrawer.querySelector('.drawer__inner') : null;
          if (currentDrawerInner && newDrawerInner) {
            if (newDrawerInner.classList.contains('is-empty')) {
              currentDrawerInner.classList.add('is-empty');
            } else {
              currentDrawerInner.classList.remove('is-empty');
            }
          }

          // Update cart icon bubble
          const cartIconDoc = parser.parseFromString(cartIconHtml, 'text/html');
          const newCartIcon = cartIconDoc.querySelector('#cart-icon-bubble');
          const currentCartIcon = document.querySelector('#cart-icon-bubble');

          if (newCartIcon && currentCartIcon) {
            currentCartIcon.replaceWith(newCartIcon);
          }

          // Hide overlay
          hideLoadingOverlay();

          // Open cart drawer
          if (currentCartDrawer) {
            currentCartDrawer.open();
          }

          // Reset button
          setQuickAddButtonLoading(button, false);
        });
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      hideLoadingOverlay();
      setQuickAddButtonLoading(button, false);
      alert('Error adding to cart. Please try again.');
    });
  }

  function setQuickAddButtonLoading(button, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    button.classList.toggle('loading', isLoading);
    if (isLoading) {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }

    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function showLoadingOverlay() {
    let overlay = document.getElementById('quick-add-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'quick-add-overlay';
      overlay.className = 'quick-add-overlay';
      overlay.innerHTML = `
        <div class="quick-add-spinner">
          <svg class="spinner" viewBox="0 0 50 50">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
          </svg>
        </div>
      `;
      document.body.appendChild(overlay);
    }
    overlay.classList.add('active');

    // Add click handler to close overlay and cart drawer
    overlay.onclick = function(e) {
      // Only close if clicking the overlay itself, not the spinner
      if (e.target.id === 'quick-add-overlay' || e.target.classList.contains('quick-add-overlay')) {
        hideLoadingOverlay();
        closeCartDrawer();
      }
    };
  }

  function hideLoadingOverlay() {
    const overlay = document.getElementById('quick-add-overlay');
    if (overlay) {
      overlay.classList.remove('active');
      overlay.onclick = null;
    }
  }

  function closeCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('active')) {
      cartDrawer.close();
    }
  }
}
})();
